import React from 'react';

import { locationLoader } from '@/core/router/loaders/locationLoader';
import Error from '@/journey-based-listing/screens/error';
import StandardUnitListingIndex from '@/standard-unit-listing/screens/index';
import StandardUnitListingSdkIndex from '@/standard-unit-listing-sdk/screens/index';

import { wizardScreens } from './common/wizardScreens';

export function buildStandardUnitListingRoutes() {
    return [
        {
            path: '',
            element: <StandardUnitListingIndex />,
            loader: locationLoader,
            errorElement: <Error />,
        },
        {
            // Proof of concept: the same listing rebuilt on `@r6digital/rapidstor-sdk`, mounted
            // alongside the original so the two can be compared side by side.
            // See src/standard-unit-listing-sdk/MISSING-FROM-SDK.md.
            path: 'sdk',
            element: <StandardUnitListingSdkIndex />,
            loader: locationLoader,
            errorElement: <Error />,
        },
        ...wizardScreens,
    ];
}
